export default "__VITE_ASSET__BPx$y0W1__"